import { channelsInstance } from '@/api/instances'
import DatabaseFactory from '@/wrappers/database'
import { addErrorLog } from '@/wrappers/database/utils/addLog'

const getStaff = async store => {
  /**
   * Get the loggedStaff with status and counters for menu
   */
  const loggedStaffListener = await store.dispatch(
    'fetchLoggedStaff',
    store.rootState.user.user.id
  )
  store.commit('setLoggedStaffListener', loggedStaffListener)
}

const fetchLoggedStaff = async (store, id) => {
  const database = new DatabaseFactory(`staff/${id}`).getReadDatabase()

  const listener = await database.getOneStream(
    doc => {
      if (!doc.exists()) {
        return
      }
      const updatedStaff = doc.data()
      const oldStaff = store.state.loggedStaff
      const hasChangeStatusProperties = hasChangeStatusStaffProperties(
        updatedStaff,
        oldStaff
      )
      const hasChangeOnCallProperties = hasChangeOnCallStaffProperties(
        updatedStaff,
        oldStaff
      )

      store.commit('setLoggedStaff', updatedStaff)

      const loggedStaff = store.state.loggedStaff
      if (hasChangeOnCallProperties || hasChangeStatusProperties) {
        //Check staff status to clear or initialize chats and listeners
        store.dispatch('channel/getChatsInformation', loggedStaff, {
          root: true
        })
      }
      if (hasChangeOnCallProperties) {
        store.dispatch('virtualClinic/getVirtualClinicQueue', loggedStaff, {
          root: true
        })
      }
    },
    error =>
      addErrorLog({
        context: 'drawer/actions - fetchLoggedStaff',
        error
      })
  )

  return listener
}

/**
 * Check if staff relevant data was changed to call listeners
 * chats listeners
 * virtualClinic listeners
 * @param {*} updatedStaff
 * @param {*} oldStaff
 * @returns
 */
const hasChangeStatusStaffProperties = (updatedStaff, oldStaff) => {
  return oldStaff.status !== updatedStaff.status
}

const hasChangeOnCallStaffProperties = (updatedStaff, oldStaff) => {
  return oldStaff.isOnCall !== updatedStaff.isOnCall
}

const setLoggedStaffStatus = async (store, status) => {
  if (isTheSameStatus(store, status)) {
    return false
  }
  try {
    const staffId = store.rootState.user.user.id
    await channelsInstance.put(`staff/${staffId}/updateStatus`, {
      json: {
        status
      }
    })
    return true
  } catch (error) {
    store.dispatch(
      'errors/setError',
      {
        error,
        request: 'channel/setLoggedStaffStatus',
        message: 'Ocorreu um problema ao atualizar o status, tente novamente.'
      },
      { root: true }
    )
  }
}

const staffStatusPing = async () => {
  try {
    await channelsInstance.post('staff/ping')
  } catch (error) {
    // do nothing
  }
}

const isTheSameStatus = (store, status) => {
  return status === store.rootState.channel.loggedStaff?.status
}

export default {
  fetchLoggedStaff,
  getStaff,
  setLoggedStaffStatus,
  staffStatusPing
}
